import { createStore } from 'vuex';
import api from '@/services/api';
import textService from '@/services/textService'
import { useToast } from 'vue-toastification'; // ایمپورت Toast
const toast = useToast();
import CryptoJS from 'crypto-js'; // وارد کردن کتابخانه
import { isDarkColor } from '@/utils/colorUtils';
import { loadTheme } from '@/themes/index';


async function generateUniqueId() {
  const parsedUrl = new URL(window.location.href); // پارس کردن URL
  const baseUrl = `${parsedUrl.protocol}//${parsedUrl.host}${parsedUrl.pathname}`; // ترکیب پروتکل، هاست و مسیر
  const hashHex = CryptoJS.SHA256(baseUrl).toString(CryptoJS.enc.Hex); // تولید هش و تبدیل به رشته هگزادسیمال
  return hashHex; // بازگشت شناسه یکتا
}

function generateRandomEightDigitNumber() {
  return Math.floor(10000000 + Math.random() * 90000000); // عددی تصادفی بین 10000000 تا 99999999 تولید می‌کند
}

async function setCartInLocalStorage(cart) {
  let authTokenKey = await generateUniqueId(); 
  let CartLocalKey = "cart_"+authTokenKey
  localStorage.setItem(CartLocalKey,JSON.stringify(cart)); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
}

const store = createStore({
  state: {
    additionalInfo: "",
    activePage:"splash",
    baseLoading: false,
    loginDialogStatus: false,

    // theme
    // مقادیر: 'default' | 'dark' | 'light'
    // default = همون رنگ بکند، dark/light = استاندارد vuetify
    currentTheme: null,
    themeMode: 'default',
    defaultIsDark: false,
    primaryColor: '#1976D2', // رنگ اصلی از بکند

    info: {
      direct_title: "منوی الکترونیکی لیمو",
    },
    serviceName: {},
    baseUrl: 'https://limoapp.ir',
    fileBaseUrl: 'https://limoapp.ir',
    node_uid: '',
    authTokenKey: '', // کلید برای authToken
    authToken: '', // توکن
    mobile: '',
    // emenu
    service: {},
    bookingSelectServiceDialogStatus:false,
    cart:[],
    showCartDialogStatus:false,

    table_number:"",
    table_number_editable:true,

    orders:[],
    order:{},

    callWaiterDialogStatus:false,
    request_description:"",


    isOffline: false,
    ws: null,
    client_id: generateRandomEightDigitNumber(),

    newOrderSubmitAudio: new Audio("https://limoapp.ir/mp3/bell-1.mp3"),

    serviceEmployees: [],
    bookingSelectEmployeDialogStatus: false,
    employe: {},
    employeDays: [],
    employeDaysServices: {},
    employeServicePrice: {},
    bookingDialogStatus: false,
    day: {},
    bookingLoading: false,
    availableTimes: [],
    time: "",

    // بلاگ
    blog: {
      loading: false,
      posts: [],
      categories: [],
      page: 1,
      lastPage: 1,
      total: 0,
    },
    blogPost: {
      loading: false,
      post: null,
      category: null,
      related: [],
    },
  },
  mutations: {
    setActivePage(state, page) {
      state.activePage = page;
    },

    setTheme(state, themeModule) {
      state.currentTheme = themeModule;
    },

    setThemeMode(state, mode) {
      state.themeMode = mode;
      localStorage.setItem('themeMode', mode);
      const vuetify = window.__vuetify;
      if (!vuetify?.theme) return;
      const map = { default: 'userDefault', light: 'light', dark: 'dark' };
      vuetify.theme.global.name.value = map[mode] ?? 'userDefault';
    },

    setTableNumber(state, table_number) {
      state.table_number = table_number;
      state.table_number_editable = false;
    },
    setFormInfo(state, info) {
      state.info = Object.assign(state.info, info);
      // state.mobile = info.mobile;
      if (!!state.info.serives && state.info.serives.length > 0) {
        state.serviceName = state.info.serives.reduce((acc, item) => {
          acc[item.id] = item.title;
          return acc;
        }, {})
      }
    },
    setNodeUid(state, node_uid) {
      state.node_uid = node_uid;
    },
    setLoginDialogStatus(state, status) {
      state.loginDialogStatus = status;
    },
    setAuthToken(state, token) {
      localStorage.setItem(state.authTokenKey, token); // استفاده از کلید هش
      state.authToken = token;
    },
    setMobile(state, mobile) {
      state.mobile = mobile;
    },
    setAddresses(state, addresses) {
      state.info.addresses = addresses;
    },
    logout(state) {
      if(confirm("آیا مطمئنید؟")){
        state.authToken = '';
        state.mobile = '';
        localStorage.removeItem(state.authTokenKey); // حذف توکن با کلید هش
        if(state.ws){
          state.ws.close();
          state.ws = null;
        }
        state.activePage = "splash";
      }
    },
    async setService(state, data) {
      let service = data.service // محصول
      let variable = data.variable??{} // کدوم متغییر محصول
      let addons = data.addons??[] // افزودنی ها
      let checkedAddonAndVars = data.checked ?? false; // اینکه از کدوم صفحه امیت شده
      
      let uniqueId = `id-${Date.now()}-${Math.floor(Math.random() * 10000)}`; // شناسه یونیک هست برای افزایش تعداد یا کاهش
      if(checkedAddonAndVars){
        state.cart.push({
          uniqueId:uniqueId,
          total:1,
          id:service.id,
          price:Number.parseInt(variable.price??service.price),
          title:service.title,
          image:service.image,
          addons:addons,
          variable:variable
        });
        await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
        state.bookingSelectServiceDialogStatus = false;
        return;
      }

      state.service = service;
      // چک میکنه که ایتم متغیر اگه داره میره برای انتخاب
      if(!!service.has_variable && !!service.options && !!service.options.varibles && service.options.varibles.length > 0){
        state.bookingSelectServiceDialogStatus = true;
        return
      }
      // چک میکنه که ادان داره میره برای انتخاب
      if(!!service.options && !!service.options.addons && service.options.addons.length > 0){
        state.bookingSelectServiceDialogStatus = true;
        return
      }
      // چک میکنه که از قبل هس یا نه
      let index = state.cart.findIndex(e=>e.id == service.id);
      if(index > -1){ // اگه بود تعدادش رو زیاد میکنه
        state.cart[index].total ++;
        return;
      }

      // نبود اضافه میکنه
      state.cart.push({
        uniqueId:uniqueId,
        total:1,
        id:service.id,
        price:Number.parseInt(service.price),
        image:service.image,
        title:service.title,
        addons:addons,
        variable:variable
      });
      await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
      return
    },
   
    async removeService(state,service){
      if(state.cart.filter(e=>e.id==service.id).length == 1){
        let index = state.cart.findIndex(e=>e.id == service.id)
        if(index > -1){
          state.cart.splice(index,1);
        }
      }else{
        let index = state.cart.findIndex(e=>e.uniqueId == service.uniqueId)
        if(index > -1){
          state.cart.splice(index,1);
        } 
      }

      await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
      if(state.cart.length == 0){
        state.showCartDialogStatus = false;
      }
    },
    async increaseService(state,service){
      if(state.cart.filter(e=>e.id==service.id).length == 1){
        let index = state.cart.findIndex(e=>e.id == service.id)
        if(index > -1){
          state.cart[index].total++;
        }
      }else{
        let index = state.cart.findIndex(e=>e.uniqueId == service.uniqueId)
        if(index > -1){
          state.cart[index].total++;
        }
      }
      await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
    },
    async decreaseService(state,service){
      if(state.cart.filter(e=>e.id==service.id).length == 1){
        let index = state.cart.findIndex(e=>e.id == service.id)
        if(index > -1 && state.cart[0].total > 1){
          state.cart[index].total--;
        }else{
          state.cart[index].total = 1;
        }
      }else{
        let index = state.cart.findIndex(e=>e.uniqueId == service.uniqueId)
        if(index > -1 && state.cart[0].total > 1){
          state.cart[index].total--;
        }else{
          state.cart[index].total = 1;
        }
      }
      await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
    },
    async clearCart(state){
      state.cart = [];
      await setCartInLocalStorage(state.cart); // این برا اینکه که اگه یهویی دستش خورد رفرش شد، از اول بیاریم
    },
    setOrder(state, order) {
      order.cart = JSON.parse(order.cart)
      state.order = order;
    },


    setBookingSelectEmployeDialogStatus(state, status) {
      state.bookingSelectEmployeDialogStatus = status;
    },
    setBookingSelectServiceDialogStatus(state, status) {
      state.bookingSelectServiceDialogStatus = status;
    },
    setShowCartDialogStatusDialogStatus(state, status) {
      state.showCartDialogStatus = status;
    },
    setEmploye(state, employe) {
      state.employe = employe;
      if (!!employe.options && !!employe.options.days) {
        state.employeDays = employe.options.days.map(d => d.id);
        employe.options.days.forEach(item => {
          state.employeDaysServices[item.id] = item.services;
        });
        employe.options.services.forEach(item => {
          state.employeServicePrice[item.id] = item.price;
        });
      } else {
        state.employeDays = [];
        state.employeDaysServices = {};
      }
    },
    setBookingDialogStatus(state, status) {
      if (status == false) {
        state.service = {};
        state.serviceEmployees = [];
        state.employe = {};
        state.employeDays = [];
        state.employeDaysServices = {};
        state.employeServicePrice = {};
      }
      state.bookingDialogStatus = status;
    },
    setSelectedDay(state, day) {
      state.day = day;
    },
    setBookingLoading(state, status) {
      state.bookingLoading = status;
    },
    setAvailableTimes(state, times) {
      state.availableTimes = times;
    },
    setSelectedTime(state, time) {
      state.time = time;
    },

    changeFavicon(state) {
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.remove(); // حذف favicon قبلی
      }
      if (state.info.form_icon && state.info.form_icon.length > 5) {
        var url = state.fileBaseUrl + state.info.form_icon;
        link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = url;
        document.head.appendChild(link);
      }
    },
    loadScript(state,scriptText) {
      // ایجاد یک div موقت برای قرار دادن HTML
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = scriptText;
      document.body.appendChild(tempDiv);

      // پیدا کردن و اجرای اسکریپت‌های داخل HTML
      tempDiv.querySelectorAll("script").forEach((scriptTag) => {
        if (scriptTag.src) {
          // اگر اسکریپت src داشته باشد، آن را مجدد لود می‌کنیم
          const newScript = document.createElement("script");
          newScript.src = scriptTag.src;
          newScript.async = true;
          document.body.appendChild(newScript);
        } else {
          // اگر اسکریپت inline باشد، کد آن را اجرا می‌کنیم
          const inlineScript = document.createElement("script");
          inlineScript.textContent = scriptTag.textContent;
          document.body.appendChild(inlineScript);
        }
      });
      const children = tempDiv.children;
      for (let child of children) {
        if (child.tagName !== 'SCRIPT' && child.tagName !== 'LINK' && child.tagName !== 'META' && child.tagName !== 'TITLE' && child.tagName !== 'BASE') {
          state.additionalInfo += child.outerHTML
        }
      }
      document.body.removeChild(tempDiv);
    },

    // بلاگ
    setBlogLoading(state, status) {
      state.blog.loading = status;
    },
    setBlogList(state, data) {
      state.blog.posts = data.posts || [];
      state.blog.categories = data.categories || [];
      state.blog.page = data.page || 1;
      state.blog.lastPage = data.lastPage || 1;
      state.blog.total = data.total || 0;
    },
    setBlogPostLoading(state, status) {
      state.blogPost.loading = status;
    },
    setBlogPostData(state, data) {
      state.blogPost.post = data.post || null;
      state.blogPost.category = data.category || null;
      state.blogPost.related = data.related || [];
    },
  },
  actions: {
    initWebsocket({dispatch,state}){
      state.ws = new WebSocket("wss://limoapp.ir/ws?validator=" + state.authToken + "&client_id=" + state.client_id);
      state.ws.onopen = () => {
        console.log('WebSocket connection established.');
        state.isOffline = false;
      };
      state.ws.onmessage = (event) => {
        if (!!event && !!event.data) {
          let d = JSON.parse(event.data);
          if (!!d.type && d.type == "change_order") {
            state.newOrderSubmitAudio.play().catch((error) => {
              console.error("Error playing sound:", error);
            });
            if(!!d.content && !!d.content.id){
              state.orders =  state.orders.map(e=>e.id == d.content.id?{...e,...d.content}:e); // آپدیت لیست اردرها
              state.order = (state.order.id == d.content.id) ? {...state.order,...d.content,cart:JSON.parse(d.content.cart)}:state.order; // آپدیت آیتمی که انتخاب شده و داره نشون داده میشه
            }
          }
        }
      };
      // if ws disconect try to reconnect
      state.ws.onclose = () => {
        console.log('WebSocket connection closed.');
        state.isOffline = true;
        setTimeout(() => {
          if (!state.ws) {
            dispatch('initWebsocket');
          }
        }, 5000);
      };
    },
    async setMobileAndConnectSocket({dispatch,commit},mobile){
      commit('setMobile',mobile);
      dispatch('initWebsocket');
    },

    async fetchBaseData({ dispatch ,commit, state }) {
      state.baseLoading = true;
      try {
        const response = await api.get('/emenu/base');
        if (response.data.success) {
          commit('setFormInfo', response.data.data);
          if(!!response.data.data && !!response.data.data.mobile && response.data.data.mobile.length > 2){
            dispatch('setMobileAndConnectSocket',response.data.data.mobile);
          }
          commit('setNodeUid', response.data.data.node_uid);
          commit('changeFavicon'); // ✅ تغییر Favicon بعد از دریافت داده
          if(!!response.data.data.form_scripts && response.data.data.form_scripts.length > 20) {
            commit('loadScript', response.data.data.form_scripts);
          }
          if(!!response.data.data.lang_keyword && response.data.data.lang_keyword.length > 5) {
            textService.updateTexts(JSON.parse(response.data.data.lang_keyword));
          }

          // لود تم از form_shop_theme
          const themeName = response.data.data.theme ?? 'default';
          const themeModule = await loadTheme(themeName);
          commit('setTheme', themeModule);

          const primaryColor = (!!response.data.data.theme_color && response.data.data.theme_color.length > 2)
            ? response.data.data.theme_color
            : '#1976D2';
          state.primaryColor = primaryColor;
          const vuetifyInstance = window.__vuetify;
          if (vuetifyInstance?.theme) {
            const isColorDark = isDarkColor(primaryColor);
            // userDefault: رنگ کاربر + dark/light بر اساس luminance
            vuetifyInstance.theme.themes.value.userDefault.colors.primary = primaryColor;
            vuetifyInstance.theme.themes.value.userDefault.dark = isColorDark;
            // light و dark: primary همون رنگ کاربر، بقیه رنگ‌ها استاندارد vuetify
            vuetifyInstance.theme.themes.value.light.colors.primary = primaryColor;
            vuetifyInstance.theme.themes.value.dark.colors.primary = primaryColor;
            if (themeModule.vuetifyOverrides?.defaults) {
              vuetifyInstance.defaults.value = { ...vuetifyInstance.defaults.value, ...themeModule.vuetifyOverrides.defaults };
            }
          }

          state.defaultIsDark = isDarkColor(primaryColor);
          const savedMode = localStorage.getItem('themeMode') ?? 'default';
          commit('setThemeMode', savedMode);
        }
      } catch (error) {
        console.error(error);
      }
      state.baseLoading = false;
    },

    changeFavicon(){
      let link = document.querySelector("link[rel~='icon']");
      if (link) {
        link.remove(); // حذف favicon قبلی
      }
      if(!!this.info.form_icon && this.info.form_icon.length > 5){
        var url = this.fileBaseUrl+this.info.form_icon
        // ایجاد favicon جدید
        link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = url;
        document.head.appendChild(link);
      }
    },

    logout({ commit }) {
      if(confirm("آیا از خروجی مطمئنید؟")){
        commit('logout');
      }
    },
    async checkHoursOfEmploye({ commit, state }, day) {
      if (!!state.day && !!state.day.date && state.day.date == day.date) {
        return;
      }
      commit('setSelectedDay', day);
      commit('setBookingLoading', true);
      try {
        const response = await api.post('/emenu/check/hours', {
          day: state.day,
          employe_id: state.employe.id,
          service_id: state.service.id,
          id: state.info.form_id
        });
        if (response.data.success) {
          commit('setAvailableTimes', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },

    
    async SubmitCallWaiter({ commit, state },data) {
      var table_number = data.table_number;
      var request_description = data.request_description;
      if(table_number.length == 0){
        toast.error('لطفا شماره میز را تکمیل نمایید.!');
        return;
      }
      
      commit('setBookingLoading', true);
      try {
        const response = await api.post('/emenu/waiter/call', {
          request_description:request_description,
          table_number:table_number,
          id: state.info.form_id,
          services_form_id: state.info.services_form_id,
        });
        if (response.data.success) {
          state.callWaiterDialogStatus = false;
          state.request_description = "";
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async SubmitOrder({ commit, state },data) {
      if (state.authToken == '') {
        toast.error('برای ثبت سفارش باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }

      var payment_method = data.payment_method;
      var order_type = data.order_type;
      var table_number = data.table_number;
      var delivery_address = data.delivery_address;
      var order_description = data.order_description;
      if(payment_method == 0 || order_type == 0){
        toast.error('لطفا شیوه پرداخت و نحوه سفارش را تکمیل نمایید.!');
        return;
      }

      if(order_type == 3 && delivery_address.length == 0){
        toast.error('لطفا آدرس تحویل سفارش را تکمیل نمایید.!');
        return;
      }
      if(order_type == 1 && (table_number.length == 0 || Number.parseInt(table_number) < 1)){
        toast.error('لطفا شماره میز را تکمیل نمایید.!');
        return;
      }

      // if(payment_method == 3 && order_description.length == 0){
      //   let ind = state.info.payment_methods.findIndex(e=>e.id == payment_method);
      //   if(ind > -1){
      //     let paymet = state.info.payment_methods[ind];
      //     if(paymet.description.length > 0){
      //       toast.error(paymet.description);
      //       return;
      //     }
      //   }
      // }

      
      commit('setBookingLoading', true);
      try {
        const response = await api.post('/emenu/order/submit', {
          cart: state.cart,
          payment_method:payment_method,
          order_type:order_type,
          table_number:table_number,
          delivery_address:delivery_address,
          order_description:order_description,
          id: state.info.form_id,
          force_pay:Number.parseInt(payment_method) == 4
        });
        if (response.data.success) {
          commit('clearCart');
          commit('setActivePage',"orders_history");
          if(!!response.data.data && response.data.data.length > 0){
            setTimeout(() => {
              window.location.href = response.data.data;
            }, 3000);
          }
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async UpdateOrder({ commit, state },data) {
      if (state.authToken == '') {
        toast.error('برای ثبت سفارش باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }

      var order_id = data.order_id;
      var payment_method = data.payment_method;
      var order_description = data.order_description;
      if(payment_method == 0){
        toast.error('لطفا شیوه پرداخت و نحوه سفارش را تکمیل نمایید.!');
        return;
      }

      if(payment_method == 3 && order_description.length == 0){
        let ind = state.info.payment_methods.findIndex(e=>e.id == payment_method);
        if(ind > -1){
          let paymet = state.info.payment_methods[ind];
          if(paymet.description.length > 0){
            toast.error(paymet.description);
            return;
          }
        }
      }

      
      commit('setBookingLoading', true);
      try {
        const response = await api.put('/emenu/order/item_update', {
          order_id: order_id,
          payment_method:payment_method,
          order_description:order_description,
          id: state.info.form_id,
          force_pay:false,
        });
        if (response.data.success) {
          console.log(response)
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async PayOrder({ commit, state },data) {
      if (state.authToken == '') {
        toast.error('برای ثبت سفارش باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }

      var order_id = data.order_id;
      var payment_method = data.payment_method;
      var order_description = data.order_description;
      if(payment_method == 0){
        toast.error('لطفا شیوه پرداخت و نحوه سفارش را تکمیل نمایید.!');
        return;
      }

      if(payment_method == 3 && order_description.length == 0){
        let ind = state.info.payment_methods.findIndex(e=>e.id == payment_method);
        if(ind > -1){
          let paymet = state.info.payment_methods[ind];
          if(paymet.description.length > 0){
            toast.error(paymet.description);
            return;
          }
        }
      }

      
      commit('setBookingLoading', true);
      try {
        const response = await api.put('/emenu/order/item_update', {
          order_id: order_id,
          payment_method:payment_method,
          order_description:order_description,
          id: state.info.form_id,
          force_pay:true,
        });
        if (response.data.success) {
          if (!!response.data.data && !!response.data.data.length > 0) {
            setTimeout(() => {
              window.location.href = response.data.data;
            }, 3000);
          }
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async GetOrders({ commit, state }) {
      if (state.authToken == '') {
        toast.error('برای مشاهده سفارشات باید ابتدا وارد پنل خود شوید!');
        setTimeout(() => {
          commit('setLoginDialogStatus', true);
        }, 2000);
        return;
      }
      
      commit('setBookingLoading', true);
      try {
        const response = await api.get('/emenu/order/list?id='+state.info.form_id);
        if (response.data.success) {
          state.orders = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBookingLoading', false);
    },
    async setAuthToken({ commit }, token) {
      const uniqueId = await generateUniqueId(); // تولید کلید یکتا
      commit('setAuthToken', token);
      commit('setAuthTokenKey', uniqueId); // ذخیره کلید یکتا
    },
    async fetchAuthToken({ state }) {
      state.authTokenKey = await generateUniqueId(); // تولید کلید یکتا
      state.authToken = localStorage.getItem(state.authTokenKey) || ''; // بازیابی توکن با کلید یکتا


      // این برای برگدوندن سابقه سبد خرید میاد
      let CartLocalKey = "cart_"+state.authTokenKey
      let cartData = localStorage.getItem(CartLocalKey);
      if(cartData && cartData.length > 2){
        state.cart = JSON.parse(cartData);
      }

    },
    callWaiter({state},status){
      state.callWaiterDialogStatus = status;
    },

    // بلاگ
    async fetchBlogList({ commit, state }, { category = null, page = 1 } = {}) {
      commit('setBlogLoading', true);
      try {
        const params = { page };
        if (state.info.form_id) params.id = state.info.form_id;
        if (category) params.category = category;
        const response = await api.get('/forms/form/blog/base', { params });
        if (response.data.success) {
          commit('setBlogList', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBlogLoading', false);
    },
    async fetchBlogPost({ commit, state }, slug) {
      commit('setBlogPostLoading', true);
      try {
        const params = { slug };
        if (state.info.form_id) params.id = state.info.form_id;
        const response = await api.get('forms/form/blog/post', { params });
        if (response.data.success) {
          commit('setBlogPostData', response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
      commit('setBlogPostLoading', false);
    },
  },
  getters: {
    totalCartItem(state){
      return state.cart.reduce((sum, item) => {
        return sum + item.total;
      }, 0);
    },
    calcCartItemPrice: (state) => (index) => {
      const service = state.cart[index];
      let itemPrice = Number.parseInt(service.price);

      if (service.variable?.price) {
        itemPrice = Number.parseInt(service.variable.price);
      }

      itemPrice += service.addons.reduce((sum, item) => {
        return sum + (item.total * Number.parseInt(item.price));
      }, 0);

      return itemPrice * service.total;
    },
    cartTotalPrice: (state, getters) => {
      return state.cart.reduce((sum, _, index) => {
        return sum + getters.calcCartItemPrice(index);
      }, 0);
    },
    getCounter(state) {
      return state.counter;
    },
    getBaseUrl: (state) => state.baseUrl,
    getNodeUid: (state) => state.node_uid,
    getAuthToken: (state) => state.authToken,
    // دسترسی به بلاگ - بر اساس فیلدی که بکند توی ریسپانس base برمی‌گردونه
    hasBlogAccess: (state) => !!state.info.blog_enabled,
    getOfferPrice(state) {
      if (!!state.service && !!state.employeServicePrice[state.service.id]) {
        return state.employeServicePrice[state.service.id];
      }
      return 0;
    },
    getDaysFilterByEmployeAndService(state) {
      if (!!state.info.days && state.info.days.length > 0) {
        if (!!state.employeDays && state.employeDays.length > 0) {
          if (!!state.employeDaysServices && Object.keys(state.employeDaysServices).length > 0) {
            return state.info.days
              .filter(d =>
                (
                  state.employeDays.includes(d.numOffWeek) &&
                  !!state.employeDaysServices[d.numOffWeek] &&
                  state.employeDaysServices[d.numOffWeek].includes(state.service.id)
                )
              );
          }
        }
      }
      return [];
    },
  },
});

export default store;
